import React from 'react';
import { Paper } from '@material-ui/core';


import './container.css';


/**
 * ---------------------------------------------------------------------
 * ContainerFrame
 * ---------------------------------------------------------------------
 * stateless component supports react ref
 *
 * basic container frame
 *
 * @see https://material-ui.com/api/paper/ for further informations
 *
 * from paper
 * @prop [number]  elevation      [optional] default= 10
 * @prop [bool]    square         [propnal] default=false
 * @prop [string]  variant
 * @prop [string]  component
 *
 * our props
 * @prop [node]    children
 * @prop [string]  className
 * @prop [string]  style
 * @prop [ref]     forwardedRef
 * @prop [string]  width     [ sm | md | lg | xl ]
 */
function ContainerFrame (props) {
        let cssClass = "container frame";
        if( props.className ) {
            cssClass += " " + props.className;
        }
        let cssStyle = {};
        if( props.style )
            cssStyle = props.style;

        let elevation = 10;
        if( props.elevation ) {
            elevation = props.elevation;
        }
        if( props.width ) {
            cssClass += " w-"+ props.width;
        }

        return (<Paper ref={props.forwardedRef} className={cssClass}
                        style={cssStyle}
                        component={props.component}
                        elevation={elevation}
                        square={props.square}
                        variant={props.variant}
                    >
                    {props.children}
            </Paper>);
}

/*
* ---------------------------------------------------------------------
* Export
* ---------------------------------------------------------------------
*/
export default ContainerFrame;
